import React from 'react';
import NavBar from '../components/common/NavBar';
import Footer from '../components/common/Footer';
import TopImage from "../components/common/TopImage";

const baseURL = process.env.PUBLIC_URL + '/assets/Infra';
const InfrastructureComponent = ({ title, description, imageUrls, altText, index }) => {
  const isEven = index % 2 === 0;
  const backgroundColor = isEven ? 'bg-neutral-100' : 'bg-white';

  return (
    <div className={`flex flex-col items-center mt-20 px-5 md:px-20 py-9 ${backgroundColor} max-md:px-5`}>
      <div className="text-3xl  font-medium tracking-wide text-black capitalize  text-center md:text-left">
        {title}
      </div>
      <div className="mt-4 text-base tracking-wide text-justify md:text-left mx-8  text-black max-md:max-w-full">
        {description}
        <br />
      </div>
      <div className="mt-8 w-full max-w-[929px] max-md:max-w-full">
        <div className="flex gap-5 max-md:flex-col max-md:gap-0 max-md:">
          {imageUrls.map((imageUrl, imageIndex) => (
            <div key={imageIndex} className="flex flex-col w-[33%] max-md:ml-0 max-md:w-full">
              <img
                loading="lazy"
                srcSet={`${baseURL}/${imageUrl}`}  
                alt={`${altText} ${imageIndex + 1}`}
                className="grow w-full aspect-[1.33] rounded-2xl max-md:mt-4"
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const FacilityItem = ({ children }) => (
  <div className="grow justify-center shadow-md px-5 py-4 mt- rounded-2xl bg-white">
    {children}
  </div>
);

const facilitiesRow1 = ["Drinking Water", "Labs", "Indoor Games", "Health & Medical", "IT Infrastructure"];
const facilitiesRow2 = ["Toilet Facilities", "Library", "Classroom", "Music Room", "Dance Room" ,"Lift"];


const InfraPage = () => {
  const infraData = [
    {
      title: 'Well-Lit & advanced Classroom',
      description: 'Equipped with efficient air conditioning, and cutting-edge smart class technology, our well-lit learning environments are designed to optimize student comfort and engagement. Step into our vibrant primary classrooms, where learning comes to life with colourful decor and engaging interactive resources!',
      imageUrls: ['C1.JPG', 'C2.JPG', 'C3.JPG'],
      altText: 'Classroom Image',
    },
    {
      title: 'Library',
      description: 'Explore our diverse library featuring approximately 400 books, carefully selected to cater to various interests and academic pursuits. Enhancing accessibility, we offer an e-learning network alongside our physical collection, providing students with a seamless blend of traditional and digital resources for an enriched educational journey.',
      imageUrls: ['Library1.JPG', 'Library2.JPG', 'Library3.JPG'],
      altText: 'Library Image',
    },
    {
        title: 'Computer Lab',
        description: 'Explore our cutting-edge computer lab, where innovation meets education. Equipped with the latest technology and high-speed internet, our lab offers students a dynamic space to develop essential digital skills and explore endless possibilities in coding, design, and research.',
        imageUrls: ['Computer1.JPG', 'Computer2.JPG', 'Computer3.jpg'],
        altText: 'Computer Lab Image',
      },
    {
        title: 'sports facility',
        description: 'Discover our comprehensive sports facilities designed to nurture both athleticism and teamwork. With expansive outdoor playgrounds, indoor game facilities, and a wide array of sports equipment, our school provides the perfect arena for students to excel in physical fitness and sportsmanship.',
        imageUrls: ['Sports1.JPG', 'Sports2.JPG' , 'Sports3.JPG'],
        altText: 'Sports Image',
      },
    {
        title: 'laboratories',
        description: 'Explore the realms of hands-on learning in our specialized laboratories! Our Math Lab offers a dynamic environment for exploring mathematical concepts through interactive tools and activities, while our Composite Lab provides a cutting-edge space for students to delve into the realms of science, technology, engineering, and mathematics.',
        imageUrls: [ 'Lab2.JPG' , 'Lab3.JPG', 'Lab4.jpg'],
        altText: 'Laboratories Image',
      },
    {
        title: 'washrooms',
        description: 'at our school, we prioritize comfort and inclusivity for all. Our washroom facilities are designed with care, featuring a dedicated space for specially abled individuals alongside separate, immaculately clean washrooms for boys and girls. We believe in providing a hygienic and accommodating environment for every student, ensuring their comfort and dignity throughout the school day.',
        imageUrls: ['Wash1.JPG', 'Wash2.JPG' , 'Wash3.JPG'],
        altText: 'Washrooms Image',
      },
    // Add more sections as needed
  ];

  return (
    <div>
        <NavBar/>
        <TopImage text="Infrastructure"/>
      <div>
        <div className="flex flex-col items-center   px-5 mt-20 max-md:mt-8 text-black capitalize max-w-[835px] mx-auto">
      {/* <div className="text-3xl font-bold tracking-wider mb-8">Campus </div> */}
      {/* <div className="text-base tracking-wide text-center max-md:max-w-full mb-8">
        The school's infrastructure encompasses classrooms equipped with modern
        teaching aids, laboratories for science experiments, a library filled
        with diverse resources, administrative offices for efficient management,
        recreational areas like playgrounds and sports facilities, and amenities
        such as cafeterias and restrooms, all designed to foster a conducive
        environment for learning and growth.
      </div> */}
      {/* <img
        loading="lazy"
        srcSet={`${baseURL}/Campus.jpg`}  
        alt="Campus Image"
        className="w-full aspect-[2.5] rounded-lg max-w-[750px] max-md:max-w-full"
      /> */}
    </div>
    <div className="flex flex-col items-center mx-28 max-md:mx-5">
      <div className="text-3xl  font-medium tracking-wide text-center text-black capitalize whitespace-nowrap">
        School Campus 
      </div>
      <div className="mt-4 text-base tracking-wide text-justify text-black  max-md:max-w-full">
      Welcome to our inclusive main building, Thoughtfully designed to accommodate students of all abilities. with accessibility at the forefront, our building features a dedicated entrance ramp, ensuring seamless entry for specially-abled students. <br/><br/>Experience an environment where every student is embraced and empowered to thrive, regardless of their physical abilities. Our school boasts a lush green ground, state-of-the-art labs, and a comprehensive library equipped with e-learning facilities. We strive to provide a nurturing environment where every student can thrive academically and personally.<br/> <br/>Additionally, we organize inclusive events and workshops designed to foster diversity and promote understanding among all students.
        <br />
      </div>
      <div className="self-stretch mt-8 w-full max-md:max-w-full">
        <div className="flex gap-5 max-md:flex-col max-md:gap-0 max-md:">
          <div className="flex flex-col w-6/12 max-md:ml-0 max-md:w-full ">
            <img
              loading="lazy"
              srcSet={`${baseURL}/school1.jpg`}  
              alt="Building Image 1"
              className="grow w-full mx-auto aspect-[1.5] rounded-2xl max-md:mt-4"
              />
          </div>
          <div className="flex flex-col ml-5 w-6/12 max-md:ml-0 max-md:w-full">
            <img
              loading="lazy"
              srcSet={`${baseURL}/school2.JPG`}  
              alt="Building Image 2"
              className="grow w-full mx-auto aspect-[1.5] rounded-lg max-md:mt-10"
            />
          </div>
          {/* <div className="flex flex-col ml-5 w-6/12 max-md:ml-0 max-md:w-full">
            <img
              loading="lazy"
              srcSet={`${baseURL}/school2.jpg`}  
              alt="Building Image 2"
              className="grow w-11/12 mx-auto aspect-[1.5] rounded-lg max-md:mt-10"
            />
          </div> */}
          {/* Add more image components as needed */}
        </div>
      </div>
    </div>
        </div>
        <div>
      {infraData.map((data, index) => (
        <InfrastructureComponent key={index} index={index} {...data} />
      ))}
    </div>
    <div>
    <div className="flex flex-col items-center px-20 py-12 mt-20 mb-20 max-md:mb-8 text-base tracking-wide capitalize whitespace-nowrap bg-neutral-100 text-neutral-900 max-md:px-5">
    <div className="text-3xl font-bold tracking-wide text-black">
      Facilities
    </div>
    <div className="flex gap-5 justify-between  mt-8 max-w-full w-[808px] max-md:flex-wrap">
      {facilitiesRow1.map((facility) => (
        <FacilityItem key={facility}>{facility}</FacilityItem>
      ))}
    </div>
    <div className="flex gap-5 justify-between pr-20 mt-6 max-w-full w-[808px] max-md:flex-wrap max-md:pr-5">
      {facilitiesRow2.map((facility) => (
        <FacilityItem key={facility}>{facility}</FacilityItem>
      ))}
    </div>
  </div>
    </div>
    <Footer/>
    </div>
  );
};

export default InfraPage;
